import { type CellCoordinates } from './TableStructure';

class TableRange {
  anchorPosition: CellCoordinates;
  focusPosition: CellCoordinates;
  startPosition: CellCoordinates;
  endPosition: CellCoordinates;

  static equal(range1: TableRange, range2: TableRange) {
    return (
      range1.startPosition.rowIndex === range2.startPosition.rowIndex &&
      range1.startPosition.columnIndex === range2.startPosition.columnIndex &&
      range1.endPosition.rowIndex === range2.endPosition.rowIndex &&
      range1.endPosition.columnIndex === range2.endPosition.columnIndex
    );
  }

  constructor(anchorPosition: CellCoordinates, focusPosition: CellCoordinates) {
    this.anchorPosition = anchorPosition;
    this.focusPosition = focusPosition;
    this.normalize();
  }

  get isBackward() {
    return (
      this.anchorPosition.rowIndex > this.focusPosition.rowIndex ||
      (this.anchorPosition.rowIndex === this.focusPosition.rowIndex &&
        this.anchorPosition.columnIndex > this.focusPosition.columnIndex)
    );
  }

  get isCollapsed() {
    const { rows, columns } = this.size;
    return rows <= 1 && columns <= 1;
  }

  get size() {
    const { startPosition, endPosition } = this;
    if (!startPosition || !endPosition) {
      return { rows: 0, columns: 0 };
    }
    return {
      rows: endPosition.rowIndex - startPosition.rowIndex + 1,
      columns: endPosition.columnIndex - startPosition.columnIndex + 1,
    };
  }

  normalize() {
    const { rowIndex: anchorRow, columnIndex: anchorColumn } =
      this.anchorPosition;
    const { rowIndex: focusRow, columnIndex: focusColumn } = this.focusPosition;

    this.startPosition = {
      rowIndex: Math.min(anchorRow, focusRow),
      columnIndex: Math.min(anchorColumn, focusColumn),
    };

    this.endPosition = {
      rowIndex: Math.max(anchorRow, focusRow),
      columnIndex: Math.max(anchorColumn, focusColumn),
    };
  }
}

export default TableRange;
